/* TooCut Shop currency conversion patch — v1.0 (2026-07-25)
 * Runs on any page containing .tc-shop (i.e., /pages/shop). Reads Shopify.currency
 * (populated by Shopify Markets multi-currency), and rewrites hardcoded USD prices
 * from the shop's pack tiles + main price row + save badges into the customer's
 * presentment currency. Uses MutationObserver so the shop's own updateCard() JS
 * re-writes (on toggle click) get re-converted immediately.
 * Companion to toocut-product.js v3.3 which does the same for PDPs.
 */
(function() {
  var root = document.querySelector('.tc-shop');
  if (!root) return;
  var SC = (window.Shopify && window.Shopify.currency) || {};
  var activeCode = (SC.active || 'USD').toUpperCase();
  var rate = parseFloat(SC.rate) || 1.0;
  if (activeCode === 'USD' && rate === 1.0) return; // no-op for USD viewers
  var ZERO_DEC = { JPY:1, KRW:1, HUF:1, ISK:1, CLP:1, VND:1, XOF:1, XAF:1, XPF:1, RWF:1, UGX:1, VUV:1, DJF:1, KMF:1, PYG:1, BIF:1, GNF:1, UYI:1 };
  var PREFIX = {
    USD:'US$', CAD:'CA$', AUD:'A$', NZD:'NZ$', SGD:'S$', HKD:'HK$',
    GBP:'£', EUR:'€', JPY:'¥', KRW:'₩', ILS:'₪',
    CHF:'CHF ', SEK:'kr ', DKK:'kr ', NOK:'kr ', PLN:'zł ', CZK:'Kč ',
    AED:'AED ', MYR:'RM ', INR:'₹'
  };
  function fmt(usd) {
    if (isNaN(usd)) usd = 0;
    var val = usd * rate;
    var decimals = ZERO_DEC[activeCode] ? 0 : 2;
    var num = decimals === 0 ? String(Math.round(val)) : val.toFixed(2);
    var parts = num.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var pfx = PREFIX[activeCode] || (activeCode + ' ');
    return pfx + parts.join('.');
  }
  // Parse a text node like '$104.50' or 'SAVE $14' and return the numeric USD.
  function parseUsd(txt) {
    var m = String(txt).match(/\$\s*([0-9]+(?:\.[0-9]+)?)/);
    return m ? parseFloat(m[1]) : NaN;
  }
  // Rewrite one text node from USD to presentment.
  function convertNode(el, prefixTxt) {
    if (!el) return;
    var txt = (el.textContent || '').trim();
    if (!txt) return;
    // Skip if already converted (contains our prefix or ISO code)
    var pfx = PREFIX[activeCode] || (activeCode + ' ');
    if (txt.indexOf(pfx) === 0 || txt.indexOf(activeCode) === 0) return;
    var usd = parseUsd(txt);
    if (isNaN(usd)) return;
    var converted = fmt(usd);
    el.textContent = (prefixTxt || '') + converted;
  }
  function sweep() {
    root.querySelectorAll('.tc-shop__pack-price, .tc-shop__pack-anchor, .tc-shop__price, .tc-shop__compare').forEach(function(el){ convertNode(el, ''); });
    root.querySelectorAll('.tc-shop__pack-save').forEach(function(el){
      var txt = (el.textContent || '').trim();
      if (!txt) return;
      var pfx = PREFIX[activeCode] || (activeCode + ' ');
      if (txt.indexOf('SAVE ' + pfx) === 0 || txt.indexOf('SAVE ' + activeCode) === 0) return;
      var usd = parseUsd(txt);
      if (isNaN(usd)) return;
      var converted = fmt(usd).replace(/[.,]00$/, '');
      el.textContent = 'SAVE ' + converted;
    });
  }
  // Initial sweep + observer to catch shop's inline updateCard() re-writes
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ sweep(); attach(); });
  } else { sweep(); attach(); }
  function attach() {
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function(muts) {
      var need = false;
      muts.forEach(function(m) {
        for (var i = 0; i < m.addedNodes.length; i++) { need = true; break; }
        if (m.type === 'characterData') need = true;
      });
      if (need) sweep();
    });
    mo.observe(root, { subtree: true, childList: true, characterData: true });
  }
})();
